module.exports = __webpack_public_path__ + "static/media/overlay-color@3x.f126899d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/WorkoutPlanBackgrounds/bg5/overlay-color@3x.png
// module id = 1235
// module chunks = 2